<template>
  <div>
    <van-pull-refresh v-model="isLoading" @refresh="refresh()">
    <div class="lp">
      <!--轮播图-->
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image.pic" style="width: 100%;"/>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!--通知公告-->
    <div class="note" v-if="noticeList && noticeList.length > 0">
      <div class="note-title">
        <h2><img src="@/assets/gao.png"></h2>
        <i></i>
        <a class="more" @click="getNotice">查看更多</a>
      </div>
      <ul>
        <li v-for="(item, index) in noticeList" :key="index">
          <a href="#" @click="getNoticeDetail(item)" v-if="index < 3" class="clearfiex" >{{ item.title }}</a>
        </li>
      </ul>
    </div>

      <!--快捷入口-->
      <div class="q-exit">
        <van-swipe class="my-swipe" indicator-color="white">
          <div v-for="(item,index) in venueClassOptions" :key="index">
            <van-swipe-item>
              <span v-for="(e,i) in item" :key="i" @click="getVenue(e)">
                <img v-if="e.icon" :src="fileDisplayPrefix + e.icon">
                  {{ e.venueClassName }}
              </span>
            </van-swipe-item>
          </div>
        </van-swipe>
      </div>
      <!--快捷入口-end-->

    <!--运动场所--->
    <div class="index-list" v-for="(res,index) in venueInfoList" :key="index">
      <div v-if="res.infoVos.length > 0" >
      <div class="index-title">
        <h2 class="clearfiex">{{ res.venueClassName }}</h2>
        <a class="more" @click="getVenue(res)">查看更多</a>
      </div>
      <div>
        <div class="list-box" v-for="(item, index) in res.infoVos" :key="index">
          <div class="list-top" @click="toDetail(item)">
            <img :src="fileDisplayPrefix + (item.picUrls || '').split(',')[0]"/>
            <div class="list-r">
              <h2>{{ item.name }}</h2>
              <div class="taglist">
                <van-tag plain type="primary" v-for="(item, index) in (item.sportTypeValue || '').split(',')"
                         :key="index">
                  {{ item }}
                </van-tag>
              </div>
              <div class="adress"><img src="@/assets/adress.png">{{ item.address }}</div>
            </div>
          </div>
          <span class="y-but" @click="toDetail(item)">立即预约</span>
        </div>
      </div>
    </div>
    </div>

    </van-pull-refresh>
  </div>
</template>

<script>
import {Lazyload} from 'vant';
import {getIndexPic, getNoticeList, getVenueInfoList} from "@/api/index/index";
import {FILE_DISPLAY_PREFIX} from "../../api/upload";
import noticeIndex from "./components/noticeIndex";
import {queryList,getSlideOptions} from "@/api/venue/venue";
export default {
  name: 'Index',
  // eslint-disable-next-line vue/no-unused-components
  components: {Lazyload, noticeIndex},
  data() {
    return {
      active: 0,
      isLoading: false,
      // 文件显示前缀
      fileDisplayPrefix: FILE_DISPLAY_PREFIX,
      images: [],
      noticeList: [],
      venueInfoList: [],
      queryParams: {},
      venueClassOptions:[],
      data: {
        records: [],
        current: 1,
        size: 3,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      },
    }
  },
  created() {
    //判断登录
    if (!this.$common.isLogin()) {
      return
    }

    this.refresh();

  },
  methods: {
    refresh(){
      this.getList()
      this.getIndexPic()
      this.getVenueInfoList()
      this.getNoticeList()
      this.getVenueClassOptions()

      setTimeout(() => {
        this.isLoading = false;
        this.count++;
      }, 1000);
    },
    getVenueClassOptions(){
      getSlideOptions().then(res => {
        if (res.code === 10000) {
          this.venueClassOptions = res.result

          // 补全完整的一组
          const length = this.venueClassOptions.length
          if (length > 0) {
            const lastList = this.venueClassOptions[length - 1]
            if (lastList.length < 5) {
              const addLen = 5 - lastList.length
              for (let i = 0; i < addLen; i++) {
                lastList.push({})
              }
            }
          }
        }
      })
    },


    getVenueInfoList(){
      getVenueInfoList().then(res => {
        if (res.code === 10000) {
          this.venueInfoList = res.result
        }
      })

    },

    getNoticeList(){
      //公告
      getNoticeList().then(res => {
        if (res.code === 10000) {
          this.noticeList = res.result
        }
      })

    },


    getIndexPic(){
      // 获得首页轮播图
      getIndexPic().then(res => {
        if (res.code === 10000) {
          this.images = res.result.map(item => {
            const pic = this.fileDisplayPrefix + item.picUrl
            return ({pic: pic})
          })
        }
      })
    },

    getNoticeDetail(item){
      this.$router.push({path: `/components/noticeDetail?id=${item.id}`})
    },

    getList() {
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size
      queryList(this.queryParams).then(res => {
        if (res.code === 10000) {
          this.data.records = res.result.records
        }
      })
    },

    getNotice() {
      this.$router.push({path: `/components/noticeIndex`})
    },

    toDetail(item) {
      this.$router.push({path: `/venue/detail?id=${item.id}`})
    },

    getVenue(item) {
      this.$store.commit('setVenueClassId', item.id)
      this.$router.push({path: `/venue`})
    }

  }
}
</script>

<style scoped>
.q-exit {
  height: 121px;
  background: #FFFFFF;
  border-radius: 6px;
  margin: 0 10px;
  margin-bottom: 10px;
  padding: 0 10px;
}

.my-swipe {
  height: 121px !important;
}

.my-swipe .van-swipe-item {
  background: none !important;

}

.van-swipe-item span {
  margin-right: 17px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  line-height: 16px;
}

.van-swipe-item span:nth-child(5) {
  margin-right: 0;
}

.van-swipe-item span img {
  display: flex;
  width: 52px;
  height: 52px;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  border-radius: 100px;
}

.lp {
  padding: 10px;
}

.van-swipe {
  height: 187px;
  border-radius: 6px;
  overflow: hidden;
}

/deep/ .van-swipe__indicator {
  background: #999999 !important;
}

/deep/ .van-swipe__indicator--active {
  width: 20px;
  border-radius: 100px;
  background: #1989fa !important;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 14px;
  text-align: center;
  background-color: #39a9ed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 15px;
}

.note {
  height: 121px;
  background: #FFFFFF;
  border-radius: 6px;
  margin: 0 10px;
  padding: 0 15px;
  margin-bottom: 10px;
}

.note-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 0px 0;
  position: relative;
}

.note-title h2 img {
  width: 42px;
  display: flex;
}

.more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 18px;
  border: 1px solid #585858;
  border-radius: 14px;
  font-size: 11px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.note-title i {
  display: flex;
  flex: 1;
  height: 1px;
  border-bottom: 1px dashed #dedede;
  margin: 0 5px;
}

.note ul li {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.note ul li a::before {
  width: 4px;
  height: 4px;
  background: #B2B2B2;
  border-radius: 50%;
  margin-right: 5px;
  float: left;
  position: relative;
  top: 5px;
}

.note ul li a {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: left;
}

.index-list {
  padding: 0 10px;
}

.index-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.index-title h2 {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding: 10px 0;
}

.index-title h2::before {
  width: 4px;
  height: 16px;
  background: #2C68E4;
  border-radius: 5px;
  margin-right: 5px;
}

</style>
